<template>
  <div
    :class="[
      $style['grid'],
      { [$style[`grid--${type}`]]: type },
    ]">
    <slot />
  </div>
</template>
<script setup lang="ts">
defineProps<{
  type?: String | Boolean
}>()
</script>
<style lang="scss" module>
.grid {
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr)); // 12-cell grid
  grid-auto-flow: row;
  grid-auto-columns: 1fr;
  grid-gap: calc(var(--spacing ) * 3);
  width: 100%;

  @media (max-width: #{$breakpoint-tablet}) {
    grid-gap: calc(var(--spacing ) * 2);
  }

  &--padding-mobile {
    @media (max-width: #{$breakpoint-tablet}) {
      padding: calc(var(--spacing) * 2);
    }
  }

  &--no-margin {
    margin: 0;
  }

  &--no-gap {
    grid-gap: 0;
  }

  &--big-row-gap {
    @media (min-width: #{$breakpoint-mobile}) {
      row-gap: calc(var(--spacing) * 10);
      grid-gap:calc(var(--spacing ) * 5);
    }
  }

  &--compact {
    grid-gap: var(--spacing);
  }

  &--margin-top-xl {
    margin-top: calc(var(--spacing ) * 4);
  }

  &--products {
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    grid-gap: calc(var(--spacing ) * 2);
    padding: calc(var(--spacing) * 2);

    @media (min-width: #{$breakpoint-mobile}) {
      grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    }

    // Tablet and up
    @media (min-width: #{$breakpoint-tablet}) {
      grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
      grid-gap: calc(var(--spacing ) * 6);
      padding: 0 calc(var(--spacing ) * 2);
    }
  }
}
</style>
